const listdevice = (state = [], action) => {
  switch (action.type) {
    case 'LIST_DEVICE':
        return [
            ...state,
      {
        type: "LIST_DEVICE",
        dispositivo: action.dispositivo,
        descricao: action.descricao
      }
    ]
    
    default:
      return state
  }
}

export default listdevice